import React, { Component } from "react"

class Description extends Component {
  render() {

    let description = this.props.house

    return(
      <div className="wrap--mini">
        <div className="description">
          <div className="formatted-content">
            <div
              className="description__content"
              dangerouslySetInnerHTML={{
                __html: description
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Description



// WEBPACK FOOTER //
// ./src/components/Description/index.js